<!-- 任务流程 -->
<template>
  <basicContainer>
    <el-tabs tab-position="top" type="card" v-model="activeName" @tab-click="handleClickmytask">
      <el-tab-pane label="我的任务" name="first">
        <span slot="label"> 我的任务<el-badge :value="wdrw" v-if="wdrw" :max="99" class="item"></el-badge></span>
        <easyCruds ref="taskTable" :tableInfo="taskForm.mainTable" @mainTableReload="taskTableReload"
          @taskSplit="taskSplitRow" @taskToDo="taskToDoRow">
          <template slot="taskBtnForm" slot-scope="{index, row}">
            <el-button type="text" size="mini" @click="taskSplitRow(index, row)" v-if="row.splitUrl">拆分</el-button>
            <el-button type="text" size="mini" @click="taskToDoRow(index, row)" v-if="row.applyUrl">办理</el-button>
          </template>
          <template slot="ratio" slot-scope="{row}">
            <el-link type="primary" v-if="row.ratio!='-'" @click="showDialog(row)">{{row.ratio}}</el-link>
            <span v-else>{{row.ratio}}</span>
          </template>
        </easyCruds>
      </el-tab-pane>
      <el-tab-pane label="我的申请" name="second">
        <easyCruds ref="applyTable" :tableInfo="applyForm.mainTable" @mainTableReload="applyTableReload"
          @applyView="applyViewRow">
          <template slot="applyBtnForm" slot-scope="{index, row}">
            <el-button type="text" size="mini" @click="applyViewRow(index, row)" v-if="row.viewUrl">查看</el-button>
          </template>
          <template slot="ratio" slot-scope="{row}">
            <el-link v-if="row.ratio!='-'" type="primary" @click="showDialog(row)">{{row.ratio}}</el-link>
            <span v-else>{{row.ratio}}</span>
          </template>
        </easyCruds>
      </el-tab-pane>
      <el-tab-pane label="我的参与" name="third">
        <easyCruds ref="processedTable" :tableInfo="processedForm.mainTable" @mainTableReload="processedTableReload"
          @applyView="processedViewRow">
          <template slot="processedBtnForm" slot-scope="{index, row}">
            <template>
              <el-button type="text" size="mini" @click="processedViewRow(index, row)" v-if="row.viewUrl">查看</el-button>
            </template>
          </template>
          <template slot="ratio" slot-scope="{row}">
            <el-link v-if="row.ratio!='-'" type="primary" @click="showDialog(row)">{{row.ratio}}</el-link>
            <span v-else>{{row.ratio}}</span>
          </template>
        </easyCruds>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="子任务详情" :visible.sync="dialogVisible" width="60%" v-if="dialogVisible" :before-close="handleClose">
      <div>
        <easyCruds ref="ChildTasksTable" :tableInfo="ChildTasksForm.mainTable" @mainTableReload="ChildTasksTableReload">
        </easyCruds>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">好的</el-button>
      </span>
    </el-dialog>
    <el-dialog append-to-body width="80%" top="2vh" :close-on-click-modal="false" v-dialogDrag class="avue-dialog"
      :title="FORMDATA.title" :visible.sync="FORMDATA.dialogVisible" v-if="FORMDATA.dialogVisible">
      <div class="iframeMain">
        <iframe :src="FORMDATA.viewDataUrl" frameborder="0" height="100%"></iframe>
      </div>
    </el-dialog>
  </basicContainer>
</template>

<script>
export default {
  name: 'Administrativeprocess',
  data() {
    return {
      dialogVisible: false,
      activeName: 'first',
      wdrw: 0,
      FORMDATA: {
        title: '',
        viewDataUrl: '',
        queryData: '',
        dialogVisible: false
      },
      taskForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            search_xl: 8,
            search_lg: 12,
            search_md: 24,
            search_sm: 24,
            loading: false,
            height: 550,
            stripe: true,
            selection: false,
            index: false,
            columns: [
              {
                prop: 'rwlx',
                label: '任务类型',
                type: 'select',
                isSearchCondition: true,
                width: 150,
                isTag: true,
                tagFilter: function (e) {
                  let dicvalue = ''
                  for (let i = 0; i < this.dicsj.length; i++) {
                    if (e === this.dicsj[i].value) {
                      dicvalue = this.dicsj[i].label
                      break
                    } else {
                      dicvalue = '无'
                    }
                  }
                  return { data: dicvalue, type: 'primary' }
                },
                dicData: [],
                dicsj: []
              },
              {
                prop: 'yjrwmc',
                label: '一级任务名称',
                type: 'input',
                isSearchCondition: true,
                width: 150
              },
              {
                prop: 'ejrwmc',
                label: '二级任务名称',
                type: 'input',
                isSearchCondition: true,
                width: 150
              },
              // {
              //   prop: 'sjrwsx',
              //   label: '三级任务属性',
              //   type: 'select',
              //   slot: true,
              //   sortable: false,
              //   isSearchCondition: true,
              //   width: 150,
              //   isTag: true,
              //   tagFilter: function(e) {
              //     let dicvalue = ''
              //     for (let i = 0; i < this.dicData.length; i++) {
              //       if (e === this.dicData[i].value) {
              //         dicvalue = this.dicData[i].label
              //         break
              //       } else {
              //         dicvalue = '无'
              //       }
              //     }
              //     return { data: dicvalue, type: 'primary' }
              //   },
              //   dicData: []
              // },
              {
                prop: 'keyword',
                label: '关键字',
                isSearchCondition: true,
                type: 'input',
                showInTable: false
              },
              {
                prop: 'taskName',
                label: '四级任务',
                // dataFilter: value => value || '已完成',
                type: 'input',
                isSearchCondition: true,
                width: 300
              },
              // {
              //   prop: 'xmmc',
              //   label: '所属项目',
              //   type: 'input',
              //   width: 140
              // },
              {
                prop: 'creator',
                label: '发起人',
                type: 'input',
                showInTable: false
              },
              {
                prop: 'mainProcessCode',
                label: '主任务编号',
                type: 'input',
                showInTable: false
              },
              //   {
              //     prop: 'parentProcessCode',
              //     label: '父流程编号',
              //     type: 'input'
              //   },
              //   {
              //     prop: 'parentTaskName',
              //     label: '父任务名称',
              //     type: 'input'
              //   },
              {
                prop: 'taskOwner',
                label: '任务下发人',
                type: 'input',
                width: 100
              },
              {
                prop: 'ratio',
                label: '子任务状态',
                slotName: 'ratio',
                type: 'input',
                width: 100
              },
              {
                prop: 'ruTask',
                label: '当前节点',
                type: 'input',
                width: 80
              },
              {
                prop: 'requestComplteTime',
                label: '要求完成时间',
                type: 'date',
                width: 140
              },
              {
                prop: 'lczt',
                label: '状态',
                width: 80,
                isTag: true,
                tagFilter: function (e) {
                  if (e === '进行中') {
                    return { data: e, type: 'primary' }
                  } else if (e === '已延期') {
                    return { data: e, type: 'danger' }
                  } else {
                    return { data: e, type: 'info' }
                  }
                }
              }

            ],
            operation: {
              width: '120',
              slotName: 'taskBtnForm',
              operations: [
                {
                  title: '拆分',
                  clickEvent: 'taskSplit'
                },
                {
                  title: '办理',
                  clickEvent: 'taskToDo'
                }
              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      applyForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            search_xl: 8,
            search_lg: 12,
            search_md: 24,
            search_sm: 24,
            loading: false,
            height: 550,
            stripe: true,
            selection: false,
            index: false,
            columns: [
              //   {
              //     prop: 'processCode',
              //     label: '任务编码',
              //     type: 'input',
              //     isSearchCondition: true
              //   },
              {
                prop: 'rwlx',
                label: '任务类型',
                type: 'select',
                isSearchCondition: true,
                width: 150,
                isTag: true,
                tagFilter: function (e) {
                  let dicvalue = ''
                  for (let i = 0; i < this.dicsj.length; i++) {
                    if (e === this.dicsj[i].value) {
                      dicvalue = this.dicsj[i].label
                      break
                    } else {
                      dicvalue = '无'
                    }
                  }
                  return { data: dicvalue, type: 'primary' }
                },
                dicData: [],
                dicsj: []
              },
              {
                prop: 'yjrwmc',
                label: '一级任务名称',
                type: 'input',
                isSearchCondition: true,
                width: 150
              },
              {
                prop: 'ejrwmc',
                label: '二级任务名称',
                type: 'input',
                isSearchCondition: true,
                width: 150
              },
              // {
              //   prop: 'sjrwsx',
              //   label: '三级任务属性',
              //   type: 'select',
              //   slot: true,
              //   sortable: false,
              //   isSearchCondition: true,
              //   width: 150,
              //   isTag: true,
              //   tagFilter: function(e) {
              //     let dicvalue = ''
              //     for (let i = 0; i < this.dicData.length; i++) {
              //       if (e === this.dicData[i].value) {
              //         dicvalue = this.dicData[i].label
              //         break
              //       } else {
              //         dicvalue = '无'
              //       }
              //     }
              //     return { data: dicvalue, type: 'primary' }
              //   },
              //   dicData: []
              // },
              {
                prop: 'keyword',
                label: '关键字',
                isSearchCondition: true,
                type: 'input',
                showInTable: false
              },
              {
                prop: 'taskName',
                label: '三级任务',
                // dataFilter: value => value || '已完成',
                type: 'input',
                isSearchCondition: true,
                width: 300
              },
              // {
              //   prop: 'xmmc',
              //   label: '所属项目',
              //   type: 'input'
              // },
              {
                prop: 'requestComplteTime',
                label: '要求完成时间',
                // dataFilter: value => dateFormat(new Date(value)),
                type: 'input',
                width: 140
              },
              {
                prop: 'ratio',
                label: '子任务状态',
                slotName: 'ratio',
                type: 'input',
                width: 100
              },
              {
                prop: 'ruTask',
                label: '当前节点',
                type: 'input',
                width: 130
              },
              {
                prop: 'creator',
                label: '发起人',
                type: 'input',
                showInTable: false
              },
              //   {
              //     prop: 'mainProcessCode',
              //     label: '主任务编号',
              //     type: 'input',
              //     showInTable: false
              //   },
              //   {
              //     prop: 'parentProcessCode',
              //     label: '父流程编号',
              //     type: 'input'
              //   },
              //   {
              //     prop: 'parentTaskName',
              //     label: '父任务名称',
              //     type: 'input'
              //   },
              //   {
              //     prop: 'taskOwner',
              //     label: '任务下发人',
              //     type: 'input'
              //   },
              {
                prop: 'taskAssigneeName',
                label: '当前执行人',
                type: 'input',
                width: 100
              },
              {
                prop: 'lczt',
                label: '状态',
                width: 140,
                isTag: true,
                tagFilter: function (e) {
                  if (e === '进行中') {
                    return { data: e, type: 'primary' }
                  } else if (e === '已延期') {
                    return { data: e, type: 'danger' }
                  } else {
                    return { data: e, type: 'info' }
                  }
                }
              }

            ],
            operation: {
              width: '150',
              slotName: 'applyBtnForm',
              operations: [
                {
                  title: '查看',
                  clickEvent: 'applyView'
                }
              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      processedForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            search_xl: 8,
            search_lg: 12,
            search_md: 24,
            search_sm: 24,
            loading: false,
            height: 550,
            stripe: true,
            selection: false,
            index: false,
            columns: [
              //   {
              //     prop: 'processCode',
              //     label: '任务编码',
              //     type: 'input',
              //     isSearchCondition: true
              //   },
              {
                prop: 'rwlx',
                label: '任务类型',
                type: 'select',
                isSearchCondition: true,
                width: 150,
                isTag: true,
                tagFilter: function (e) {
                  let dicvalue = ''
                  for (let i = 0; i < this.dicsj.length; i++) {
                    if (e === this.dicsj[i].value) {
                      dicvalue = this.dicsj[i].label
                      break
                    } else {
                      dicvalue = '无'
                    }
                  }
                  return { data: dicvalue, type: 'primary' }
                },
                dicData: [],
                dicsj: []
              },
              {
                prop: 'yjrwmc',
                label: '一级任务名称',
                type: 'input',
                isSearchCondition: true,
                width: 150
              },
              {
                prop: 'ejrwmc',
                label: '二级任务名称',
                type: 'input',
                isSearchCondition: true,
                width: 150
              },
              // {
              //   prop: 'sjrwsx',
              //   label: '三级任务属性',
              //   type: 'select',
              //   slot: true,
              //   sortable: false,
              //   isSearchCondition: true,
              //   width: 150,
              //   isTag: true,
              //   tagFilter: function(e) {
              //     let dicvalue = ''
              //     for (let i = 0; i < this.dicData.length; i++) {
              //       if (e === this.dicData[i].value) {
              //         dicvalue = this.dicData[i].label
              //         break
              //       } else {
              //         dicvalue = '无'
              //       }
              //     }
              //     return { data: dicvalue, type: 'primary' }
              //   },
              //   dicData: []
              // },
              {
                prop: 'keyword',
                label: '关键字',
                isSearchCondition: true,
                type: 'input',
                showInTable: false
              },
              {
                prop: 'taskName',
                label: '四级任务',
                // dataFilter: value => value || '已完成',
                type: 'input',
                isSearchCondition: true,
                width: 300
              },
              // {
              //   prop: 'xmmc',
              //   label: '所属项目',
              //   type: 'input'
              // },
              {
                prop: 'requestComplteTime',
                label: '要求完成时间',
                // dataFilter: value => dateFormat(new Date(value)),
                type: 'input',
                width: 140
              },
              {
                prop: 'ratio',
                label: '子任务状态',
                slotName: 'ratio',
                type: 'input',
                width: 100
              },
              {
                prop: 'ruTask',
                label: '当前节点',
                type: 'input',
                width: 130
              },
              {
                prop: 'creator',
                label: '发起人',
                type: 'input',
                showInTable: false
              },
              //   {
              //     prop: 'mainProcessCode',
              //     label: '主任务编号',
              //     type: 'input',
              //     showInTable: false
              //   },
              //   {
              //     prop: 'parentProcessCode',
              //     label: '父流程编号',
              //     type: 'input'
              //   },
              //   {
              //     prop: 'parentTaskName',
              //     label: '父任务名称',
              //     type: 'input'
              //   },
              //   {
              //     prop: 'taskOwner',
              //     label: '任务下发人',
              //     type: 'input'
              //   },
              {
                prop: 'taskAssigneeName',
                label: '当前执行人',
                type: 'input',
                width: 100
              },
              {
                prop: 'lczt',
                label: '状态',
                width: 140,
                isTag: true,
                tagFilter: function (e) {
                  if (e === '进行中') {
                    return { data: e, type: 'primary' }
                  } else if (e === '已延期') {
                    return { data: e, type: 'danger' }
                  } else {
                    return { data: e, type: 'info' }
                  }
                }
              }

            ],
            operation: {
              width: '150',
              slotName: 'processedBtnForm',
              operations: [
                {
                  title: '查看',
                  clickEvent: 'applyView'
                }
              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      ChildTasksForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            selection: false,
            index: false,
            columns: [
              {
                prop: 'ZRWBH',
                label: '任务编码',
                type: 'input',
                width: 160
              },
              {
                prop: 'ZRWMC',
                label: '任务名称',
                type: 'input',
                width: 140
              },
              {
                prop: 'ZRWYQWCSJ',
                label: '要求完成时间',
                type: 'input',
                width: 140
              },
              {
                prop: 'ZRWWCSJ',
                label: '实际完成时间',
                type: 'input',
                width: 140
              },
              {
                prop: 'ZRWWCQK',
                label: '完成情况',
                type: 'input',
                width: 130
              },
              {
                prop: 'ZFQRPJ',
                label: '评价',
                type: 'input',
                width: 130
              },
              {
                prop: 'RWZXRXM',
                label: '执行人',
                type: 'input'
              }
            ],
            operation: {
              width: '150'
            },
            tableData: [],
            // paging: {
            //   currentPage: 1,
            //   pageSizes: [10, 15, 20, 25],
            //   pageSize: 10,
            //   total: 0
            // },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      }
    }
  },
  mounted() {
    // 自己任务类型
    this.$http.post('/fighter-workflow-saas/xrbManager/queryTaskType', null, {
      params: {
        pageNum: 1,
        pageSize: 999
      }
    }).then(response => {
      let list = response.data.records
      const listdata = list.map((item) => {
        return { label: item.lbmc, value: item.id }
      })
      this.$set(this.taskForm.mainTable.table.columns[this.findArray(this.taskForm.mainTable.table.columns, 'rwlx', 'prop')], 'dicData', listdata)
      this.$set(this.processedForm.mainTable.table.columns[this.findArray(this.processedForm.mainTable.table.columns, 'rwlx', 'prop')], 'dicData', listdata)
      this.$set(this.applyForm.mainTable.table.columns[this.findArray(this.applyForm.mainTable.table.columns, 'rwlx', 'prop')], 'dicData', listdata)
    })
    // 通用任务类型
    this.$http.post('/fighter-workflow-saas//rwxxzd/listAllTaskType').then(response => {
      let list = response.data
      this.$set(this.taskForm.mainTable.table.columns[this.findArray(this.taskForm.mainTable.table.columns, 'rwlx', 'prop')], 'dicsj', list)
      this.$set(this.processedForm.mainTable.table.columns[this.findArray(this.processedForm.mainTable.table.columns, 'rwlx', 'prop')], 'dicsj', list)
      this.$set(this.applyForm.mainTable.table.columns[this.findArray(this.applyForm.mainTable.table.columns, 'rwlx', 'prop')], 'dicsj', list)
    })
    // 三级任务属性
    // this.$http.post('/fighter-workflow-saas/rwxxzd/listTaskProperties').then(res => {
    //   console.log(res)
    //   const list = res.data.map((item) => {
    //     return { label: item.itemValue, value: item.itemCode }
    //   })
    //   this.$set(this.taskForm.mainTable.table.columns[this.findArray(this.taskForm.mainTable.table.columns, 'sjrwsx', 'prop')], 'dicData', list)
    //   this.$set(this.applyForm.mainTable.table.columns[this.findArray(this.applyForm.mainTable.table.columns, 'sjrwsx', 'prop')], 'dicData', list)
    //   this.$set(this.processedForm.mainTable.table.columns[this.findArray(this.processedForm.mainTable.table.columns, 'sjrwsx', 'prop')], 'dicData', list)
    // })
    this.taskTableReload({})
    this.applyTableReload({})
    this.processedTableReload({})
    this.getRwNum()
  },
  methods: {
    showDialog(row) {
      if (row.ratio !== '-') {
        this.ChildTasksTableReload({}, row.processCode)
        this.dialogVisible = true
      }
    },
    getRwNum: function () {
      let params = {
        pageNum: 1,
        pageSize: 10
      }
      this.$http
        .get('/taskDict/my-todo', {
          params
        })
        .then(response => {
          this.wdrw = response.data.total
        })
    },
    // handleClickmytask(tab, event) {
    //   if (tab.paneName == 'first') {
    //     this.$refs.taskTable.doLayout()
    //   } else if (tab.paneName == 'third') {
    //     this.$refs.applyTable.doLayout()
    //   }
    // },
    load(params, url, data) {
      this[data].mainTable.table.loading = true
      params = params || {}
      // params.jszgh=this.jszgh;
      this[data].mainTable.table.loading = true
      if (!params.pageSize) {
        params.pageSize = 10
      }
      if (!params.pageNum) {
        params.pageNum = 1
      }
      this.url = url
      this.$http
        .get(url, {
          params
        })
        .then(response => {
          this[data].mainTable.table.loading = false
          if (response.code === 200) {
            response.data.records
              .filter(
                item =>
                  item.taskAssigneeName === '' ||
                  item.taskAssigneeName === null ||
                  item.taskAssigneeName === ''
              )
              .forEach(item => {
                item.taskAssigneeName = item.lastExecutorName
              })
            // 成功之后的数据

            this[data].mainTable.table.tableData = response.data.records
            this[data].mainTable.table.paging.total =
              response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(response => {
          this[data].mainTable.table.loading = false
        })
    },
    taskTableReload(params) {
      this.load(params, '/taskDict/my-todo', 'taskForm')
    },
    applyTableReload(params) {
      this.load(params, '/taskDict/my-apply', 'applyForm')
    },
    processedTableReload(params) {
      this.load(params, '/taskDict/i-did-apply', 'processedForm')
    },
    ChildTasksTableReload(params, code) {
      params.parentProcessCode = code
      this.$http
        .post('/taskDict/listChildTasks', null, {
          params
        })
        .then(response => {
          this.ChildTasksForm.mainTable.table.loading = false
          if (response.code === 200) {
            response.data
              .filter(
                item =>
                  item.taskAssigneeName === '' ||
                  item.taskAssigneeName === null ||
                  item.taskAssigneeName === ''
              )
              .forEach(item => {
                item.taskAssigneeName = item.lastExecutorName
              })
            // 成功之后的数据

            this.ChildTasksForm.mainTable.table.tableData = response.data
            //   this.ChildTasksForm.mainTable.table.paging.total =
            //                 response.data.total || response.data.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(response => {
          this.ChildTasksForm.mainTable.table.loading = false
        })
    },
    taskSplitRow(index, row) {
      this.$router.push({
        path: '/startProcess',
        query: {
          processDefinitionKey: row.splitUrl.substring(row.splitUrl.indexOf('=') + 1, row.splitUrl.indexOf('&')),
          mainProcessCode: row.mainProcessCode,
          dataId: row.splitUrl.substring(row.splitUrl.indexOf('dataId') + 7, row.splitUrl.indexOf('PprocessCode') - 1),
          PprocessCode: row.splitUrl.substring(row.splitUrl.indexOf('PprocessCode') + 13, row.splitUrl.indexOf('LEVELS') - 1),
          LEVELS: row.splitUrl.substring(row.splitUrl.lastIndexOf('=') + 1, row.splitUrl.length)
        }
      })
      // if (row.splitUrl) {
      //   window.open(OAUTH2_CONFIG.FRONT_DEPLOYMENT_ADDRESS + row.splitUrl)
      // }
    },
    taskToDoRow(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.applyUrl.substring(row.applyUrl.indexOf('=') + 1, row.applyUrl.indexOf('&')),
          processInstanceId: row.processInstanceId,
          taskId: row.applyUrl.substring(row.applyUrl.indexOf('taskId') + 7, row.applyUrl.indexOf('formId') - 1),
          formId: row.applyUrl.substring(row.applyUrl.indexOf('formId') + 7, row.applyUrl.indexOf('pageKey') - 1),
          pageKey: 'DO',
          FromId: row.applyUrl.substring(row.applyUrl.lastIndexOf('=') + 1, row.applyUrl.length)
        }
      })
      // if (row.applyUrl) {
      //   window.open(OAUTH2_CONFIG.FRONT_DEPLOYMENT_ADDRESS + row.applyUrl)
      // }
    },
    // 我的申请 查看/拆分/办理
    // applyViewRow(index, row) {
    //    console.log(row)
    //   //   console.log(row)
    // //   if (row.viewUrl) {
    // //     window.open(OAUTH2_CONFIG.FRONT_DEPLOYMENT_ADDRESS + row.viewUrl)
    // //   }
    //   this.$router.push({
    //     name: 'workFlow-view-myApply',
    //     query: {
    //       businessKey: row.viewUrl.substring(row.viewUrl.indexOf('=') + 1, row.viewUrl.indexOf('&')),
    //       processInstanceId: row.processInstanceId,
    //       taskId: null,
    //       formId: null,
    //       pageKey: 'VIEW',
    //       FromId: 'application'
    //     }
    //   })
    // },
    applyViewRow(index, row) {
      let businessKeyurl = row.viewUrl.substring(row.viewUrl.indexOf('=') + 1, row.viewUrl.indexOf('&'))
      this.FORMDATA.dialogVisible = true
      this.FORMDATA.title = '查看'
      this.FORMDATA.queryData = 'businessKey' + '=' + businessKeyurl + '&' + 'processInstanceId' + '=' + row.processInstanceId + '&' + 'pageKey' + '=' + 'VIEW' + '&' + 'FromId' + '=' + 'application' + '&' + 'isIframe' + '=' + 'true'
      this.FORMDATA.viewDataUrl = '/#/applyViewForm?' + this.FORMDATA.queryData
    },
    processedViewRow(index, row) {
      // this.$router.push({
      //   name: 'workFlow-view-myApply',
      //   query: {
      //     businessKey: row.id,
      //     processInstanceId: row.processInstanceId,
      //     taskId: null,
      //     formId: null,
      //     pageKey: 'VIEW',
      //     FromId: ''
      //   }
      // })
      this.FORMDATA.dialogVisible = true
      this.FORMDATA.title = ' 查看'
      this.FORMDATA.queryData = 'businessKey' + '=' + row.id + '&' + 'processInstanceId' + '=' + row.processInstanceId + '&' + 'pageKey' + '=' + 'VIEW' + '&' + 'FromId' + '=' + '' + '&' + 'isIframe' + '=' + 'true'
      this.FORMDATA.viewDataUrl = '/#/applyViewForm?' + this.FORMDATA.queryData
    }
  }
}
</script>
<style lang="scss" scoped>
.iframeMain {
  height: 70vh;
}
:deep(.el-tabs) {
  .el-tabs__header {
    border: none;
  }
  .el-tabs__header .el-tabs__item {
    border: none;
  }
  .el-tabs__header .el-tabs__nav {
    border: none;
    background-color: #f0f2f5;
    border-radius: 5px;
    padding: 3px 15px;
  }
  .el-tabs__header .el-tabs__item.is-active {
    background-color: #ffffff;
    border-radius: 5px;
  }
  .el-tabs__item {
    width: 33.33%;
  }
}
:deep(.el-tag.el-tag--info) {
  background-color: transparent;
  border-color: transparent;
  color: #909399;
}
</style>
